import * as yup from 'yup';
import i18n from 'i18next';

const contactsFormSchema = yup.object().shape({
  contacts: yup
    .array()
    .transform((value) => {
      const filteredValue = value;
      if (value.length > 1) filteredValue.pop();
      return filteredValue;
    })
    .of(
      yup.object().shape({
        name: yup
          .string()
          .trim()
          .required(() => i18n.t('common.message.requiredField')),
        phoneNumber: yup
          .string()
          .matches(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/, () => i18n.t('mission.message.invalidPhoneNumberFormat'))
          .required(() => i18n.t('common.message.requiredField')),
        email: yup
          .string()
          .email()
          .required(() => i18n.t('common.message.requiredField')),
      })
    ),
});

export default contactsFormSchema;
